import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/esm/Button';
import { firestore, auth } from '../../firebase/firebaseConfig';
import { setDoc, doc, getDocs, collection, addDoc, onSnapshot } from "@firebase/firestore";
import { onAuthStateChanged } from 'firebase/auth';

function SignUp ( props ) {
    let [ login, setLogin ] = useState( false );
    let [ phone, setPhone ] = useState( props.details.phone );
    let [ pincodesArray, setPincodesArray ] = useState( [] );
    let [ details, setDetails ] = useState( {} );

    async function registerUser ( event ) {
        setLogin( true );
        event.preventDefault();
        let form = event.target;
        document.querySelector( ".saving-details" ).style.display = "block";

        await setDoc( doc( firestore, "users", auth.currentUser.uid ), {
            name: form.name.value,
            mobile: form.phone.value,
            email: form.email.value,
            address: form.address.value,
            pincode: form.pincode.value,
            uid: auth.currentUser.uid
        } );

        await setDoc( doc( firestore, "users/" + auth.currentUser.uid + "/wallet", "wallet_id" ), {
            wallet_balance: 50
        } )

        await addDoc( collection( firestore, "transaction_history_global" ), {
            order_doc: "Welcome Offer",
            amount: 50,
            order_total: 0,
            customer_name: form.name.value,
            via: "Welcome Offer",
            order_id: "Welcome Offer",
            customer_id: auth.currentUser.uid,
            time: new Date(),
            source: "website"
        } )

        await addDoc( collection( firestore, "users/" + auth.currentUser.uid + "/transaction_history" ), {
            order_id: null,
            amount: "+Rs. 50",
            timestamp: new Date(),
            message: "Free cashback worth",
            method: "Welcome Offer",
            source: "website"
        } )

        document.querySelector( ".saving-details" ).style.display = "none";
        document.querySelector( ".saved-details" ).style.display = "block";
        localStorage.removeItem( "user_details" )
        setTimeout( () => {
            document.querySelector( ".saved-details" ).style.display = "none";
            window.location.href = "/";
        }, 2000 );
    }

    async function onload () {
        let pincodesDoc = await getDocs( collection( firestore, "pin" ) )
        let pincodeArray = [];
        pincodesDoc.forEach( ( element ) => {
            pincodeArray.push( element.id );
        } )
        setPincodesArray( [ ...pincodeArray ] );

        document.querySelector( ".loader-container" ).style.display = "none";
    }

    useEffect( () => {
        document.title = "Laundry Buddy - Sign Up";
        document.querySelector( ".loader-container" ).style.display = "flex";
        onAuthStateChanged( auth, ( user ) => {
            if ( user ) {
                onSnapshot( doc( firestore, "users", user.uid ), ( snapshot ) => {
                    if ( snapshot.exists() && props.login === true ) {
                        // window.location.href = "/";
                    } else {
                        if ( localStorage.getItem( "user_details" ) ) {
                            setDetails( JSON.parse( localStorage.getItem( "user_details" ) ) );
                        }
                        onload();
                        setPhone( user.phoneNumber );
                        document.querySelector( ".loader-container" ).style.display = "none";
                    }
                } );
            } else {
                window.location.href = "/login";
            }
        } )
    }, [] )

    return (
        <div className='registration-container signup' style={{ height: "100%" }}>
            <div className='registration-inner-container'>
                <div className='registration-container-content'>
                    <a className='registration-image laptop' href="https://play.google.com/store/apps/details?id=com.laundrybuddy.laundry_buddy" target="_blank" rel="noreferrer"><img src={require( "../../images/registration-image-2.webp" )} alt="" style={{ width: "80%", height: "auto" }} /></a>
                    <a className='registration-image mobile' href="https://play.google.com/store/apps/details?id=com.laundrybuddy.laundry_buddy" target="_blank" rel="noreferrer"><img src={require( "../../images/registration-image-mobile.webp" )} alt="" style={{ width: "80%", height: "auto" }} /></a>
                </div>
                <form className='registration-container-form' onSubmit={event => registerUser( event )}>
                    <h3>Tell Us Something About Yourself</h3>
                    <h6>Create Your Account Now</h6>
                    <div className='form-input-container' style={{ marginTop: "1rem" }}>
                        <div className='form-input-head'>
                            Name
                        </div>
                        <div className='form-input'>
                            <input type="text" placeholder='Enter Your Name' name="name" defaultValue={details.name} required autoFocus />
                        </div>
                    </div>
                    <div className='form-input-container' style={{ marginTop: "0.2rem" }}>
                        <div className='form-input-head'>
                            Email Id
                        </div>
                        <div className='form-input'>
                            <input type="email" placeholder='Enter Your Email Id' name="email" defaultValue={details.email} required />
                        </div>
                    </div>
                    <div className='form-input-container' style={{ marginTop: "0.2rem" }}>
                        <div className='form-input-head'>
                            Phone Number
                        </div>
                        <div className='form-input'>
                            <input type="tel" placeholder='Enter Your Phone Number' name="phone" value={phone} minLength={10} maxLength={10} readOnly />
                        </div>
                    </div>
                    <div className='form-input-container' style={{ marginTop: "0.2rem" }}>
                        <div className='form-input-head'>
                            Address
                        </div>
                        <div className='form-input'>
                            <input type="text" placeholder='Enter Your Address' name="address" defaultValue={details.address} required />
                        </div>
                    </div>
                    <div className='form-input-container' style={{ marginTop: "0.2rem" }}>
                        <div className='form-input-head'>
                            Pincode
                        </div>
                        <div className='form-input'>
                            <select name="pincode" required>
                                <option value="">Select Option</option>
                                {pincodesArray.map( ( element ) => (
                                    <option value={element}>{element}</option>
                                ) )}
                            </select>
                        </div>
                    </div>
                    <span className='saving-details message hidden'>Saving Details ....</span>
                    <span className='saved-details message hidden'>Details Saved....</span>
                    <Button type="submit" disabled={login === true ? true : false}>Register</Button>
                </form>
            </div>
        </div>
    )
}

export default SignUp